<div class="white_round">
    <div *ngFor="let iIpcom of us.currentUser['ipcoms']" class="suip_item" (click)="editIpcom(iIpcom)">
        <app-button-single-line-arrow><span class="suip_id">{{iIpcom.id}}</span>{{iIpcom.name}}</app-button-single-line-arrow>
    </div>
</div>
<app-plus-button *ngIf="us.currentUser.permissions?.permissions.ipcom_settings.create && us.currentUser.company_id === 0" (plusClicked)="addIpcom()"></app-plus-button>